export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null;
}

export function allElementsAreDefined<T>(
  array: (T | undefined | null)[]
): array is T[] {
  return array.every(isDefined);
}
